import React, {Component} from 'react';
import {Dimensions, KeyboardAvoidingView, ScrollView, Text, View,} from 'react-native';
import {i18n} from "../../../i18n/i18n";
import {LoaderState} from "@helpers/LoaderHelper";
import {
    Accommodation,
    HostHouseDelete,
    HostHousesApi, HostReservationsApi, HostResourcesApi,
    House,
    Reservation,
    ReservationGuestBean,
    Resource
} from "@services/src";
import {goBack, NavigationProps} from "@helpers/NavigationHelper";
import {LocationHelper} from "@helpers/LocationHelper";
import {
    getDoorFromNavigationProps,
    getHouseDeleteFromNavigationProps,
    getReservationGuestFromNavigationProps
} from "@helpers/NavigationDataHelper";
import houseDetailScreenStyle from "@styles/host/house/HouseDetailScreenStyle";
import globalScreenStyle from "@styles/GlobalStyle";
import {
    AvenirBookGreyLabelText,
    AvenirBookPrimaryText,
    AvenirBookServiceGreyText,
    AvenirLightText
} from "@components/StyledText";
import {ConfirmButtonBottom} from "@components/ConfirmButton";
import {AlertHelper} from "@helpers/AlertHelper";
import Colors from "../../../config/Colors";
import {DeleteButton} from "@components/DeleteButton";
import {Logger} from "@helpers/Logger";
import { error } from 'console';


interface State extends LoaderState {
    recap: ReservationGuestBean[],
    door: Resource,
}

export default class DoorDeleteRecap extends Component<NavigationProps, State> {
    static navigationOptions = {};

    constructor(props) {
        super(props);


        this.state = {
            loading: false,
            recap: getReservationGuestFromNavigationProps(this),
            door: getDoorFromNavigationProps(this),
        };

        console.log("Recap: ", JSON.stringify(this.state.recap));
        console.log("Recap: ", this.state.recap.length);
    }

    render(){
        return (
            <View style={{flex: 1}}>
                <ScrollView
                    style={[houseDetailScreenStyle.container, globalScreenStyle.globalMargins]}
                    contentContainerStyle={houseDetailScreenStyle.contentContainer}>
                    { this.state.recap.length > 0 ?
                        <View >
                            <AvenirBookPrimaryText
                                style={{textAlign: "center"}}> {i18n.t("screens.door_delete.message")} </AvenirBookPrimaryText>
                            <View style={{margin: 5}}>
                                <AvenirBookPrimaryText
                                    style={{marginBottom: 10}}>{i18n.t("screens.door_delete.reservations")}</AvenirBookPrimaryText>
                                <AvenirBookServiceGreyText style={{marginBottom: 10}}>{i18n.t("screens.door_delete.reservations_alert")}</AvenirBookServiceGreyText>
                                    {this.state.recap.map((reservationGuestBean, key) => (
                                        <ReservationBlock reservationGuestBean={reservationGuestBean}
                                                          deleteReservation={this.deleteReservation}
                                                          context={this}/>
                                                        
                                    ))}
                            </View>
                    </View> :
                        <View style={{marginBottom: 50}}>
                            <AvenirBookPrimaryText
                            style={{textAlign: "center"}}> {i18n.t("screens.house_delete.nothing_to_delete_message")} </AvenirBookPrimaryText>
                        </View>
                    }
                </ScrollView>
                <ConfirmButtonBottom active={this.state.recap && this.state.recap.length == 0} onPress={() => {if (this.state.recap.length == 0)deleteResource(this)}} title={i18n.t('buttons.confirm')}/>
            </View>
        );
    }


    deleteReservation(context, id){
        AlertHelper.showConfirmAlert(function (confirmed) {
            if (confirmed) {
                new HostReservationsApi(context).apiHostReservationsIdDelete({id: id}).then(resp => {

                    let recap = context.state.recap;
                    let keyave;
                    recap.map((bean, key)=>{
                        if (bean.reservation.id == id)
                            keyave = key;
                    });
                    recap.splice(keyave, 1);
                    context.setState({recap: recap});
                }).catch(error => {
                    console.log(error);
                    AlertHelper.showSimpleErrorAlert();
                });
            }
        });
    }
}

function deleteResource(context){
    AlertHelper.showConfirmAlert(function (confirmed) {
        if (confirmed)
            new HostResourcesApi(context).apiHostResourcesIdDelete({id: context.state.door.id}).then((resp) => {
                context.props.navigation.popToTop();
            }).catch(error => {
                AlertHelper.showSimpleErrorAlert();
            });
    });
}

export interface ResourceBlockProps {
    resource: Resource,
}

export interface AccommodationBlockProps {
    accommodation: Accommodation,
}

export interface ReservationBlockProps {
    reservationGuestBean: ReservationGuestBean,
    deleteReservation: (context, id: number) => void,
    context: any,
}



export function ResourceBlock(props: ResourceBlockProps) {
    console.log("Rendering ResourceBlock");
    return (
        <View style={{width: "100%", padding: 5,borderWidth: 1, borderColor: Colors.primaryColor, flexDirection: "column", marginTop: 5, marginBottom: 5}}>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.name") }</AvenirBookGreyLabelText><AvenirLightText> { props.resource.name} </AvenirLightText>
            </View>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.serial") }</AvenirBookGreyLabelText><AvenirLightText> { props.resource.serial} </AvenirLightText>
            </View>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.type")}</AvenirBookGreyLabelText><AvenirLightText> { props.resource.type} </AvenirLightText>
            </View>
        </View>
    );
}

export function AccommodationBlock(props: AccommodationBlockProps) {
    console.log("Rendering AccommodationBlock");
    return (
        <View style={{width: "100%", padding: 5,borderWidth: 1, borderColor: Colors.primaryColor,  flexDirection: "column", marginTop: 5, marginBottom: 5}}>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.name") }</AvenirBookGreyLabelText><AvenirLightText> { props.accommodation.name} </AvenirLightText>
            </View>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.description") }</AvenirBookGreyLabelText><AvenirLightText> { props.accommodation.description} </AvenirLightText>
            </View>
            <View style={{flexDirection: "row"}}>
                <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.availability")}</AvenirBookGreyLabelText><AvenirLightText> { props.accommodation.availability} </AvenirLightText>
            </View>
        </View>
    );
}

export function ReservationBlock(props: ReservationBlockProps) {
    console.log("Rendering ReservationBlock");
    return (
        <View style={{width: "100%", padding: 5,borderWidth: 1, borderColor: Colors.primaryColor,  flexDirection: "row", marginTop: 5, marginBottom: 5, display: "flex"}}>
            <View style={{flexDirection: "column"}}>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.name") }</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.guest.first_name} </AvenirLightText>
                </View>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.surname") }</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.guest.last_name} </AvenirLightText>
                </View>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.from")}</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.reservation.start_at} </AvenirLightText>
                </View>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.to")}</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.reservation.end_at} </AvenirLightText>
                </View>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.email")}</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.guest.email} </AvenirLightText>
                </View>
                <View style={{flexDirection: "row"}}>
                    <AvenirBookGreyLabelText>{i18n.t("screens.house_delete.phone_number")}</AvenirBookGreyLabelText><AvenirLightText> { props.reservationGuestBean.guest.mobile} </AvenirLightText>
                </View>
            </View>

                <View style={{position: "absolute", right:10, top: "45%"}}>
                    <DeleteButton onPress={() => props.deleteReservation(props.context, props.reservationGuestBean.reservation.id)}/>
                </View>

        </View>
    );
}